import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

//styles
import { Wrapper, Image } from './Actor.styles';

const Actor = ({ name, character, imageUrl, actorId }) => (
    <Wrapper as={Link} to={`/actor/${actorId}`}>
        <Image src={imageUrl} alt={name} />
        <h3>{name}</h3>
        <p>{character}</p>
    </Wrapper>
);

Actor.propTypes = {
    name: PropTypes.string,
    character: PropTypes.string,
    imageUrl: PropTypes.string,
    actorId: PropTypes.number,
};

export default Actor;
